export default {
  WEBCONSTRUP: 3848,
  CARDOSO: 4471,
};
